import {tilLokalDatoIgnorerTs} from "../tjenester/Datoer";

export function tilLokalDatoIgnorerTsFilterForInjisering() {
    return [tilLokalDatoIgnorerTsFilter];
}

export function tilLokalDatoIgnorerTsFilter():Function {
    return function (dato) {
        if (typeof dato === 'undefined' || dato === null) return '';
        return tilLokalDatoIgnorerTs(dato);
    };
}
